(function () {
  if (!window.requestAnimationFrame) {
    return;
  }
  document.querySelectorAll('.ag-article').forEach(function (article) {
    var toc = article.querySelector('[data-ag-toc]');
    var prose = article.querySelector('[data-ag-prose]');
    if (!toc || !prose || toc.getAttribute('data-ag-toc-enhanced') === 'true') {
      return;
    }
    var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]'));
    var pairs = links.map(function (link) {
      var id = link.hash.slice(1);
      try { id = decodeURIComponent(id); } catch (e) { /* malformed hash — use raw */ }
      var heading = document.getElementById(id);
      return heading && prose.contains(heading)
        ? { heading: heading, link: link }
        : null;
    }).filter(Boolean);
    var ticking = false;

    if (!pairs.length) {
      return;
    }
    function activate(activeLink) {
      pairs.forEach(function (pair) {
        if (pair.link === activeLink) {
          pair.link.setAttribute('data-ag-active', 'true');
          pair.link.setAttribute('aria-current', 'location');
          return;
        }
        pair.link.removeAttribute('data-ag-active');
        pair.link.removeAttribute('aria-current');
      });
    }
    function update() {
      var activePair = pairs[0];
      ticking = false;
      pairs.forEach(function (pair) {
        if (pair.heading.getBoundingClientRect().top <= 128) {
          activePair = pair;
        }
      });
      activate(activePair.link);
    }
    function requestUpdate() {
      if (ticking) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame(update);
    }
    toc.setAttribute('data-ag-toc-enhanced', 'true');
    update();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  });
})();
